import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { SecondaryButtonText } from "../ui/Button";
import service from "../../services/api/service";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, triggerDataSelector } from "../../services/redux/slices/authSlice";
import { loginTypeData } from "../../utils/helpers";
import { encrypt } from "../../utils/crypto";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
type Props = {
  hours?: number;
  minutes?: number;
  seconds?: number;
  resendOtpType: "auth" | "withdraw";
  resetPreviousOtp: () => void;
  isTriggerDataEmpty?: boolean;
};

const ResendOtpTimer = ({
  hours = 0,
  minutes = 0,
  seconds = 0,
  resendOtpType,
  resetPreviousOtp,
  isTriggerDataEmpty,
}: Props) => {
  const dispatch = useDispatch();
  const { otpUserData } = useSelector(authSelector);
  const triggerData = useSelector(triggerDataSelector);
  const [paused, setPaused] = useState(false);
  const [over, setOver] = useState(false);
  const [time, setTime] = useState({
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  });
  const registerKey = useSelector((state: any) => state.keyRegistrar.keys);
  const mobileNumbers = useSelector(
    (state: any) => state.keyRegistrar.mobileNumbers
  );
  const lanNumbers = useSelector((state: any) => state.keyRegistrar.lanNumbers);
  const handleResendOtp = () => {
    if (resendOtpType?.includes("auth")) {
      console.log(loginTypeData(otpUserData), mobileNumbers)
      const payload = { key: encrypt(loginTypeData(otpUserData)) };
      const reSendOtpPayload = {
        lan: encrypt(lanNumbers),
        key: encrypt(mobileNumbers),
      };
      if (registerKey == "register") {
        service?.auth
          ?.reSendRegisterOtp(reSendOtpPayload)
          .then((res) => {
            if (res?.status === 200) {
              reset();
              resetPreviousOtp();
            }
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.message || "An error occurred";
            dispatch(
              setStatusPopup({
                status: "error",
                // message: `Disbursement requests are not permitted for this loan.`,
                message: errorMessage,
              })
            );
          });
      } else {

        if (isTriggerDataEmpty !== false) {
          service?.auth
            ?.sendUserOtp(payload)
            .then((res) => {
              if (res?.status === 200) {
                reset();
                resetPreviousOtp();
              }
            })
            .catch((error) => {
              const errorMessage =
                error.response?.data?.message || "An error occurred";
              dispatch(
                setStatusPopup({
                  status: "error",
                  message: errorMessage,
                })
              );
            });
        } else {
          service?.auth
            ?.sendCoApplicantOtp({
              key: encrypt(triggerData?.coApplicantMobileNumber),
              trackingId: triggerData?.submissionTrackingId,
            })
            .then((res) => {
              if (res?.status === 200) {
                reset();
                resetPreviousOtp();
              }
            })
            .catch((error) => {
              const errorMessage =
                error.response?.data?.message || "An error occurred";
              dispatch(
                setStatusPopup({
                  status: "error",
                  message: errorMessage,
                })
              );
            });
        }

      }
    }
  };

  const tick = () => {
    if (paused || over) return;
    if (time.hours == 0 && time.minutes == 0 && time.seconds == 0)
      setOver(true);
    else if (time.minutes == 0 && time.seconds == 0)
      setTime({
        hours: time.hours - 1,
        minutes: 59,
        seconds: 59,
      });
    else if (time.seconds == 0)
      setTime({
        hours: time.hours,
        minutes: time.minutes - 1,
        seconds: 59,
      });
    else
      setTime({
        hours: time.hours,
        minutes: time.minutes,
        seconds: time.seconds - 1,
      });
  };

  const reset = () => {
    setTime({
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    });
    setPaused(false);
    setOver(false);
  };

  useEffect(() => {
    let timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  }, [time]);

  return (
    <Box className="otp-timer-section">
      <Box className="otp-timer">
        {time.minutes.toString().padStart(2, "0")}:
        {time.seconds.toString().padStart(2, "0")}
      </Box>
      <SecondaryButtonText disabled={!over} onClick={() => handleResendOtp()}>
        Resend OTP
      </SecondaryButtonText>
    </Box>
  );
};

export default ResendOtpTimer;
